import DashboardShell from "@features/dashboard/layout/DashboardShell";
import FleetOverviewPage from "@features/dashboard/pages/FleetOverviewPage";
import MitigationDetailPage from "@features/dashboard/pages/MitigationDetailPage";
import PidExplorerPage from "@features/dashboard/pages/PidExplorerPage";
import PlantOverviewPage from "@features/dashboard/pages/PlantOverviewPage";
import SpofCardPage from "@features/dashboard/pages/SpofCardPage";
import SpofRegisterPage from "@features/dashboard/pages/SpofRegisterPage";
import ExpertApp from "@features/expert/ExpertApp";
import { createBrowserRouter, Navigate } from "react-router-dom";
import RequireExpert from "./auth/RequireExpert";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RequireExpert />,
    children: [{ index: true, element: <ExpertApp /> }],
  },
  {
    path: "/dashboard",
    element: <DashboardShell />,
    children: [
      { index: true, element: <FleetOverviewPage /> },
      { path: "plants", element: <PlantOverviewPage /> },
      { path: "plants/:plantId", element: <PlantOverviewPage /> },
      { path: "spofs", element: <SpofRegisterPage /> },
      { path: "spofs/:plantId/:spofId", element: <SpofCardPage /> },
      {
        path: "spofs/:plantId/:spofId/mitigations/:mitigationId",
        element: <MitigationDetailPage />,
      },
      { path: "pid-explorer", element: <PidExplorerPage /> },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);
